import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const PurposeOfSelectionList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="purposeOfSelection"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default PurposeOfSelectionList;
